import { render, staticRenderFns } from "./HomepageJoinCommunity.vue?vue&type=template&id=34aaf7be&scoped=true&"
import script from "./HomepageJoinCommunity.vue?vue&type=script&lang=ts&"
export * from "./HomepageJoinCommunity.vue?vue&type=script&lang=ts&"
import style0 from "./HomepageJoinCommunity.vue?vue&type=style&index=0&id=34aaf7be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aaf7be",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonCustomDiagramCardViewer: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonCustomDiagramCardViewer.vue').default})
